class quotation {
	constructor(config) {
		this.config = Object.assign({
			scope: '.quotation-form-wrapper',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.on('change', 'select', this.checkSelect.bind(this));
	}

	checkSelect(event) {
		const $select = $(event.currentTarget);
		const $selected = $select.find(':selected');

		const hideTarget = $select.data('hide-target');
		const showTarget = $selected.data('on-select');

		if (hideTarget) {
			$(hideTarget).addClass('d-none');
		}

		if (showTarget && showTarget !== '.hide') {
			$(showTarget).removeClass('d-none');
		}
	}
}

export default new quotation;